
import { Box, CircularProgress } from "@material-ui/core"
import "./loading.css"
const AmsLoading = (props:any) => {
    return (
        <Box display={"flex"} justifyContent="center" alignItems={"center"} height={"75vh"} >
            <CircularProgress className="progress"  />
        </Box>
    )
}

export default AmsLoading